export default "__VITE_ASSET__bfc9accf__"